var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1192 8.47887V0H26.3304V8.47887H58.6684V0H64.8797V8.47887H84.1051V49.875H77.8938V33.9155H7.10507V77.7887H60.875V84H0.893799V8.47887H20.1192ZM7.10507 27.7042V14.6901H77.8938V27.7042H7.10507Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1625 58.2742C69.6979 58.2742 67.7 60.2721 67.7 62.7367H60.875C60.875 56.5028 65.9286 51.4492 72.1625 51.4492C78.3964 51.4492 83.45 56.5028 83.45 62.7367C83.45 67.684 80.2671 71.8879 75.8374 73.4125V75.0757H69.0124L69.0125 67.1992H72.1625C74.6271 67.1992 76.625 65.2012 76.625 62.7367C76.625 60.2721 74.6271 58.2742 72.1625 58.2742Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0127 77.229V84.054H75.8377V77.229H69.0127Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarQuestion);
export default __webpack_public_path__ + "static/media/icon--calendar--question.bf2f89b5fe6ad7663060f51b7dfb7bd2.svg";
export { ForwardRef as ReactComponent };